import React from 'react'
import { checkTextTranslation, checkTranslation } from '../../utils/useful'

class NumberInput extends React.Component {
    state = {
        disabled: false
    }
    componentDidMount() {
        // console.log('propssssss', this.props.isEditing)
        if (this.props.isEditing && this.props.header.key == "nationalID") {
            this.setState({ disabled: true })
        }
    }

    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        // console.log('valueis', value)
        if (value !== null && Number(value) >= 0) {
            // console.log('MMMNU')
            this.props.changeValue(this.props.header.key, value != '' ? Number(value) : null, this.props.extra)
        }
    }


    render() {
        return (
            <div className="w-100 h-100">
                <input ref={el => this.input = el} type="number" step="any" value={this.props.data != null ? checkTranslation(this.props.data) : ''} disabled={this.state.disabled ? this.state.disabled : (this.props.disabled || this.props.header.information?.disabled)} maxLength={this.props.header.information.maxLength} onChange={(e) => this.changeInputValue(e.target)} placeholder={checkTextTranslation(this.props.header.information.placeholder)} className="transpanet-input" />
            </div>
        )
    }
}

export default NumberInput;